import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { TELEMETRY_SERVICE } from 'common/telemetry';

@Injectable()
export class ErrorHandlerService extends ErrorHandler {
  static readonly UnknownErrorMessage = 'unknown error';

  constructor(private readonly injector: Injector) {
    super();
  }

  handleError(error: any): void {
    super.handleError(error);
    const telemetryService = this.injector.get(TELEMETRY_SERVICE);
    telemetryService.reportError(error ?? ErrorHandlerService.UnknownErrorMessage);
  }
}
